import React from 'react';
import { fees } from '../mock';
import { Receipt } from 'lucide-react';

function money(n) {
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export default function Fees() {
  const total = fees.reduce((acc, cat) => acc + cat.items.reduce((s, it) => s + it.amount, 0), 0);

  return (
    <div className="max-w-[1200px] mx-auto space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-[11.5px] text-neutral-500 mono">Loan #126096012900</div>
          <h1 className="display text-[32px] font-bold tracking-tight text-neutral-900 mt-1">Fees</h1>
          <p className="text-[13px] text-neutral-500">Itemized closing cost estimate pulled from the latest LE / CD worksheet.</p>
        </div>
        <div className="rounded-2xl bg-neutral-900 text-white px-5 py-4 min-w-[240px] relative overflow-hidden noise">
          <div className="absolute inset-0 bg-dot-dark opacity-30" />
          <div className="absolute -right-4 -top-4 h-20 w-20 rounded-full bg-[hsl(var(--kf-gold))]/25 blur-2xl" />
          <div className="relative">
            <div className="text-[10.5px] uppercase tracking-[0.22em] text-[hsl(var(--kf-gold))] font-bold">Total closing cost</div>
            <div className="display text-[28px] font-bold tracking-tight mt-0.5 mono text-white">{money(total)}</div>
            <div className="text-[10.5px] text-white/60">Borrower-paid + Broker-paid</div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {fees.map((cat) => {
          const subTotal = cat.items.reduce((s, it) => s + it.amount, 0);
          return (
            <div key={cat.category} className="rounded-2xl border hairline bg-white overflow-hidden card-lift">
              <div className="px-5 py-4 border-b hairline flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="h-9 w-9 rounded-lg bg-neutral-900 text-[hsl(var(--kf-gold))] flex items-center justify-center">
                    <Receipt className="h-4 w-4" />
                  </div>
                  <div>
                    <div className="text-[10px] uppercase tracking-wider text-neutral-500 font-bold">Section</div>
                    <div className="text-[13.5px] font-bold text-neutral-900">{cat.category}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] uppercase tracking-wider text-neutral-500 font-bold">Subtotal</div>
                  <div className="mono text-[13.5px] font-bold text-neutral-900">{money(subTotal)}</div>
                </div>
              </div>
              <div className="divide-y divide-neutral-100">
                {cat.items.map((it) => (
                  <div key={it.name} className="px-5 py-3 flex items-center justify-between hover:bg-neutral-50/60">
                    <div>
                      <div className="text-[12.5px] font-bold text-neutral-900">{it.name}</div>
                      <div className="text-[10.5px] text-neutral-500">Paid by {it.paidBy}</div>
                    </div>
                    <div className="mono text-[13.5px] font-bold text-neutral-900">{money(it.amount)}</div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
